<template>
    <div class="common-layout" ref="commonLayouts" id="commonLayouts" @scroll="scrolling">
        <my-header />
        <app-main style="min-height: 100vh;" />
        <my-footer />
    </div>
</template>
<script>
import AppMain from "./components/AppMain.vue";
import MyHeader from "./components/Header.vue";
import MyFooter from "./components/Footer.vue";
export default {
    name: 'LufeidemoIndex',
    components: {
        MyHeader,
        AppMain,
        MyFooter,
    },
    data() {
        return {

        };
    },
    watch: {
        '$route.path'(newPath) {
            // console.log('路由变化00000：', newPath)
            // 监听路由的变化,  把当前路由的滚动条置顶
            const scrollContainer = this.$refs.commonLayouts;
            scrollContainer.scrollTop = 0;
            this.$store.commit("lufei/SET_current", 0);
        },

    },
    mounted() {
        // window.addEventListener("scroll", this.scrolling)
        // console.log(this.$refs.commonLayouts)
    },
    methods: {
        scrolling() {
            const scrollContainer = this.$refs.commonLayouts;
            const scrollTop = scrollContainer.scrollTop; // 垂直滚动距离（像素）
            // console.log('sssss11111111', scrollTop)
            this.$store.commit("lufei/SET_current", scrollTop);
        },
    },

};
</script>
<style lang="less" scoped>
.common-layout {
    width: 100%;
    height: 100%;
    min-height: 100%;
    background-color: #fff;
    overflow: hidden;
    overflow-y: auto !important;
}
</style>